<div class="d-flex flex-column gap-2">
  <div class="pushback-container-title title-height">
      <ng-container *ngIf="!isInTab">
        <h1 class="text-center">PushBacks</h1>
      </ng-container>
      <ng-container *ngIf="isInTab">
        <h5 class="text-center">PushBacks</h5>
      </ng-container>
  </div>

  <app-client-selection-view
        (itemSelected)="clientSelected($event)"
        (infoSelected)="infoSelected($event)"
        (informationSelected)="informationSelected($event)"
        (integrationSelected)="integrationSelected($event)"
        (destSelected)="selectDestination($event)"
        (loadingFailed)="setLoadingFailed($event)"
        (clearAll)="clearToStart()"
        [clientInformationId]="activeClientInformationId()"
        [destinationName]="destinationName()"
        [identifierId]="identifierIdValue()"
        [identifierName]="identifierNameValue()"
        [allowedDestinations]="userDestinations"
        [showLTClientSelectOption]="checkAccess(['Admin'])"
        [selectIdentifierForClients]="false"
        />

  @if(loadingFailed() === true)
  {
    <p>Error getting Pushbacks for Client. Try again later.</p>
  }
  @else
  {
    @if(gettingData() === true)
    {
      <div class="loading-display" >
        <app-lt-spinner></app-lt-spinner>
      </div>
    }
    @else if (clientDataReady() === true){
      @if(runTimes() && runTimes().length > 0){
        <app-integration-pushback-view #pushBackView
          [integrationPushBacks]="pushBacks()"
          [integrationRunTimes]="runTimes()"
          [integrationInformations]="informations()"
          [integration]="activeIntegration()"
          [hideIntegrationColumns]="isInTab"
          (itemToDelete)="setDeletingIntegrationPushBack($event)"
          (itemToEdit)="setEditingIntegrationPushBack($event)"
          [hideIntegrationColumns]="false"
          [searchedByIdentifier]="searchedByIdentifier()"
          [allowDelete]="checkAccess(['LOSTalker.Admin'])" ></app-integration-pushback-view>
      }
      @else {
          <p>No run times returned for client-integration details.</p>
      }
    }
  }
</div>

<ng-template #deletePushBackDialog>
  <h2 matDialogTitle>Confirm Deleting PushBack</h2>
  <mat-dialog-content>
    <span>The PushBack for {{selectedRunTime.importTypeDescription}} - {{selectedRunTime.destinationEndpointName}} RunTime will be deleted.</span>
    <br/>
    <span>TriggerDate: {{selectedPushBack.triggerDate | date:'yyyy-MM-dd hh:mm:ss a'}}</span>
    <br/>
    <span>LastRunTime: {{selectedPushBack.pushBackLastRunTimeDate | date:'yyyy-MM-dd hh:mm:ss a'}}</span>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button matButton matDialogClose (click)="deleteIntegrationPushBack()">Delete</button>
    <button matButton matDialogClose>Cancel</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #editPushBackDialog>
  <h2 matDialogTitle>Edit PushBack</h2>
  <mat-dialog-content>
    
    <div class="w-75">
      <app-integration-pushback-add
        [integrationRunTimes]="runTimes()"
        [integration]="activeIntegration()"
        [updatingItem]="selectedPushBack"
        [showBackButton]="false"
        (itemUpdated)="integrationPushBackUpdated($event)"></app-integration-pushback-add>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button matButton matDialogClose>Cancel</button>
  </mat-dialog-actions>
</ng-template>
